import { Classes, Menu, MenuDivider, MenuItem, Popover } from '@blueprintjs/core';
import logout from 'es/app/business-logic/services/security/logout';
import FlushCacheDialog from 'es/app/components/layout/nav/FlushCacheDialog';
import KnownAccessControls from 'es/app/security/KnownAccessControls';
import AccessControlGate from 'es/app/security/protected/AccessControlGate';
import { Logo } from 'es/app/components/logo';
import useDialogState from 'es/core/hooks/useDialogState';
import { useI18n } from 'es/core/hooks/useI18n';
import { useState } from 'react';
import { ThemeSwitch } from 'es/app/components/layout/nav/ThemeSwitch';
import styles from './NavDrawerHeader.module.css';
import { useUserStore } from 'es/app/store/GlobalStore';
import { Link } from 'react-router';
import RouteMap from 'es/app/views/system/RouteMap';
import { PersonType } from 'es/app/business-logic/domain-models/People';

export const NavDrawerHeader = () => {
    const { l10n } = useI18n('app/components', 'layout.user');
    const [showCacheDialog, handleShowCacheDialog, handleHideCacheDialog] = useDialogState();
    const [isOpen, setIsOpen] = useState(false);
    const { loggedInUser } = useUserStore();
    const { username, firstName, lastName, id } = loggedInUser ?? {};
    const name = firstName && lastName ? `${firstName} ${lastName}` : username;

    return (
        <div className={styles.navDrawerHeader}>
            <Popover
                position="right"
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                renderTarget={({ isOpen, ...rest }) => {
                    return (
                        <button {...rest} className={styles.logo} onClick={() => setIsOpen(v => !v)}>
                            <Logo />
                        </button>
                    );
                }}
                content={
                    <Menu className={Classes.ELEVATION_1}>
                        <MenuItem
                            shouldDismissPopover={false}
                            tagName="span"
                            className={styles.nonClickableMenuItem}
                            text={
                                <Link
                                    to={RouteMap.people.edit(PersonType.User, id ?? undefined).root}
                                    className={styles.userLink}
                                >
                                    {name}
                                </Link>
                            }
                        />
                        <MenuDivider />
                        <AccessControlGate requiredAccessControl={KnownAccessControls.api.system.diagnosis}>
                            <MenuItem onClick={handleShowCacheDialog} text={l10n('menu.flushCache')} />
                            <MenuDivider />
                        </AccessControlGate>
                        <MenuItem
                            shouldDismissPopover={false}
                            tagName="span"
                            className={styles.nonClickableMenuItem}
                            text={<ThemeSwitch onSelect={() => setIsOpen(false)} />}
                        />
                        <MenuDivider />
                        <MenuItem onClick={handleLogout} text={l10n('menu.logout')} />
                    </Menu>
                }
            />

            <FlushCacheDialog show={showCacheDialog} onClose={handleHideCacheDialog} />
        </div>
    );

    ////////////

    async function handleLogout() {
        await logout();
        window.location.reload();
    }
};
